{
  "type": "object",
  "properties": {
    "TaskName": { "$ref": "common_definitions.json#/definitions/TaskName" },
    "TaskDescription": {
      "$ref": "common_definitions.json#/definitions/TaskDescription"
    },
    "Instructions": {
      "$ref": "common_definitions.json#/definitions/Instructions"
    },
    "CogAtlasID": { "$ref": "common_definitions.json#/definitions/CogAtlasID" },
    "CogPOID": { "$ref": "common_definitions.json#/definitions/CogPOID" },
    "InstitutionName": {
      "$ref": "common_definitions.json#/definitions/InstitutionName"
    },
    "InstitutionAddress": {
      "$ref": "common_definitions.json#/definitions/InstitutionAddress"
    },
    "InstitutionalDepartmentName": {
      "$ref": "common_definitions.json#/definitions/InstitutionalDepartmentName"
    },
    "EpochLength": {
      "$ref": "common_definitions.json#/definitions/EpochLength"
    },
    "RecordingType": {
      "$ref": "common_definitions.json#/definitions/RecordingType"
    },
    "SubjectArtefactDescription": { "type": "string" },
    "MotionChannelCount": { "type": "number" },
    "TrackingSystemName": { "type": "string" },
    "DeviceSerialNumber": {
      "$ref": "common_definitions.json#/definitions/DeviceSerialNumber"
    },
    "SoftwareVersions": {
      "$ref": "common_definitions.json#/definitions/SoftwareVersions"
    },
    "Manufacturer": {
      "$ref": "common_definitions.json#/definitions/Manufacturer"
    },
    "ManufacturersModelName": { "type": "string", "minLength": 1 },
    "TrackedPointsCount": { "type": "number" },
    "RecordingDuration": {
      "$ref": "common_definitions.json#/definitions/RecordingDuration"
    },
    "SamplingFrequency": {
      "$ref": "common_definitions.json#/definitions/SamplingFrequency"
    },
    "SamplingFrequencyEffective": { "type": "number" },
    "SoftwareFilters": {
      "$ref": "common_definitions.json#/definitions/SoftwareFilters"
    },

    "ACCELChannelCount": { "type": "number" },
    "ANGACCELChannelCount": { "type": "number" },
    "GYROChannelCount": { "type": "number" },
    "JNTANGChannelCount": { "type": "number" },
    "MAGNChannelCount": { "type": "number" },
    "MISCChannelCount": { "type": "number" },
    "ORNTChannelCount": { "type": "number" },
    "POSChannelCount": { "type": "number" },
    "VELChannelCount": { "type": "number" },
    "LATENCYChannelCount": { "type": "number" },
    "MissingValues": { "type": "string" }
  },
  "required": ["TaskName", "SamplingFrequency"],
  "additionalProperties": false
}
